import { useEffect, useState } from "react";
import PanchangView from "../../Views/Panchang/PanchangView";
import ParentView from "../../Views/PrarentView/ParentView";
import { useDispatch, useSelector } from "react-redux";
import { getPanchangData } from "../../store/actions/templeAction";
import moment from "moment";
import dayjs from "dayjs";
import {
  generatePanchangPayload,
  getUTCIndiaTimeNow,
} from "../../utils/HelperFunctions";
function PanchangScreen() {
  const dispatch: any = useDispatch();
  const { panchangData } = useSelector((state: any) => state.temple);
  const { currentAddress, currentGPSAddress } = useSelector(
    (state: any) => state.user
  );

  useEffect(() => {
    const todayDate = getUTCIndiaTimeNow();
    const panchangData = generatePanchangPayload(currentGPSAddress, todayDate);

    dispatch(getPanchangData(panchangData));
  }, [currentGPSAddress]);

  const getPanchangDataForSelectedDate = (dateEvent: any) => {
    const formattedDate = moment(dayjs(dateEvent).toString())
      .utc()
      .format("YYYY-MM-DD hh:mm:ss");
    const panchangPaylad = generatePanchangPayload(
      currentGPSAddress,
      formattedDate
    );
    dispatch(getPanchangData(panchangPaylad));
  };
  return (
    <ParentView>
      <PanchangView
        panchangData={panchangData}
        getPanchangDataForSelectedDate={getPanchangDataForSelectedDate}
      />
    </ParentView>
  );
}

export default PanchangScreen;
